var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlanetOrbit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "26.123%",
    cy: "37.366%",
    fx: "26.123%",
    fy: "37.366%",
    r: "62.861%",
    id: "planet-orbit_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D78",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101A2C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-81.5%",
    y: "-77.3%",
    width: "263%",
    height: "263%",
    filterUnits: "objectBoundingBox",
    id: "planet-orbit_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.725490196 0 0 0 0 0.894117647 0 0 0 0 0.890196078 0 0 0 0.234320367 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "planet-orbit_svg__b",
    cx: 150.282,
    cy: 151.601,
    r: 59.508
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#6D7B8E",
    strokeWidth: 3.125,
    opacity: 0.327,
    cx: 149.934,
    cy: 149.767,
    rx: 86.536,
    ry: 86.702
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#6D7B8E",
    strokeWidth: 2.5,
    opacity: 0.176,
    cx: 149.767,
    cy: 149.767,
    r: 148.517
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#planet-orbit_svg__a)",
    xlinkHref: "#planet-orbit_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#planet-orbit_svg__c)",
    xlinkHref: "#planet-orbit_svg__b"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgPlanetOrbit as ReactComponent };